import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Z1.css";

// ⭐ Example 5 rows data – replace with your images, headings & text
import img1 from "../assets/images/item11/subitm1.jpg";
import img2 from "../assets/images/item11/subitm2.jpg";
import img3 from "../assets/images/item11/subitm3.jpg";

const rowsData = [
  {
    id: 1,
    title: "Welding Machines (Inverters)",
    text: "High-performance inverter welding machines for precise and efficient welding.",
    img: img1,
    gradient: "gradient1",
    stars: 4,
    description: `Inverter welding machines deliver stable and efficient welding performance. Lightweight and portable for on-site or workshop use. Provide smooth arc control for different welding applications.
`
  },
  {
    id: 2,
    title: "Power Tools (Drills, Grinders, Saws)",
    text: "Reliable power tools for professional construction and industrial tasks.",
    img: img2,
    gradient: "gradient2",
    stars: 5,
    description: `Power tools make heavy-duty work faster and more efficient. Include drills, grinders, saws, and other essential equipment. Built with durable materials for long-lasting performance.
`
  },
  {
    id: 3,
    title: "Hand Tools Kits",
    text: "Complete hand tool kits for everyday repairs and professional use.",
    img: img3,
    gradient: "gradient3",
    stars: 3,
    description: `Hand tool kits provide all essential tools in one organized set. Include wrenches, pliers, screwdrivers, and more. Made from high-strength materials for durability and reliability.
`
  }
];

function Z11() {
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
            onClick={() => setSelectedRow(row)}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>
              <div className="stars">
                {"★".repeat(row.stars)}
                {"☆".repeat(5 - row.stars)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* 🔹 Popup / Modal */}
      {selectedRow && (
        <div className="z1-modal-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="z1-modal"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            <h2>{selectedRow.title}</h2>

            <div className="modal-body">
              <div className="modal-img">
                <img src={selectedRow.img} alt={selectedRow.title} />
              </div>
              <div className="modal-text">
                <p>{selectedRow.description}</p>
              </div>
            </div>

            <button
              className="close-btn"
              onClick={() => setSelectedRow(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Z11;